import { ErrorInRoute } from "@core/presentation/components/routing/error-in-route/error-in-route.component.tsx";
import { Route } from "react-router";

export const AgentRoutes = {
    Agent: "/agent",
} as const;

export const agentRoutes = (
    <Route
        path={AgentRoutes.Agent}
        errorElement={<ErrorInRoute />}
        lazy={async () => {
            const { AgentModuleLayout } =
                await import("@agent/presentation/layout/agent-module.layout.tsx");
            return { Component: AgentModuleLayout };
        }}
    >
        <Route
            index
            lazy={async () => {
                const { AgentPage } =
                    await import("@agent/presentation/pages/agent/agent.page.tsx");
                return { Component: AgentPage };
            }}
        />
    </Route>
);
